// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__20gqT","obliqueLineWrap":"membershipbadge_obliqueLineWrap__8AkW8","obliqueLine":"membershipbadge_obliqueLine__1kM3p"};